<template>
    <div>
        <RegisterTypifications
            :data="editQueue"
            :active="active"
            :value="value"
            @dialog:change="eventdialog"
        />
        <v-card class="shadow-1">
            <v-card-title>
                <v-btn text color="primary" @click="registerQueue"
                    >Registrar Tipificación</v-btn
                >
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="typifications"
                :search="search"
            >
                <template v-slot:item.status="{ item }">
                    <v-chip
                        @click="changeStatus(item)"
                        outlined
                        :color="item.status ? 'success' : 'error'"
                        dark
                        >{{ item.status ? "Habilitado" : "Inactivo" }}</v-chip
                    >
                </template>
                <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click.stop="handlerEditQueue(item)"
                        >mdi-account-edit-outline</v-icon
                    >
                    <v-icon small class="mr-2" @click.stop="deleteQueue(item)"
                        >mdi-account-off-outline</v-icon
                    >
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import RegisterTypifications from "./RegisterTypifications";
export default {
    name: "ShowTypifications",
    components: {
        RegisterTypifications
    },
    data() {
        return {
            active: false,
            editQueue: {},
            value: 0,
            search: "",
            headers: [
                {
                    text: "Nombre",
                    align: "left",
                    sortable: false,
                    value: "typification.name"
                },
                { text: "Creacion", value: "typification.created_at" },
                {
                    text: "Accion",
                    value: "action",
                    sortable: false,
                    align: "center"
                }
            ],
            typifications: []
        };
    },
    created() {
        this.getTypifications();
    },
    methods: {
        async getTypifications() {
            try {
                const response = await this.$store.dispatch(
                    "typifications/SHOW_TYPIFICATIONS"
                );
                this.typifications = response.data.data;
            } catch (error) {
                console.log(error);
            }
        },
        registerQueue() {
            this.active = true;
            this.value = 0;
            this.editQueue = {
                id: "",
                name: "",
                number: ""
            };
        },
        handlerEditQueue(item) {
            this.active = true;
            this.value = 1;
            this.editQueue = {
                id: item.id,
                name: item.name,
                number: item.number
            };
        },
        async deleteQueue(item) {
            const response = await this.$store.dispatch("queue/DELETE_QUEUE", {
                id: item.id
            });
            alert(response.data.message);
        },
        eventdialog(message) {
            alert(message);
            this.active = false;
        }
    }
};
</script>
